import React, { useState, useEffect } from "react";
import { callAPI } from "../hooks/CallAPI";
import Footer from "../components/Footer.jsx";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../hooks/useLocalStorage";
import useAuth from "../hooks/useAuth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast, ToastContainer } from 'react-toastify';
import Input from "../components/FormElements/Input"; 


const SuperAdmin = () => {
    // État principal
    const [accounts, setAccounts] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [email, setEmail] = useState("");
    const [id_global, setIdGlobal] = useState("");
    const [id_contact, setIdContact] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [suggestions, setSuggestions] = useState([]);

    const navigate = useNavigate();
    const { logout } = useAuth();
    const [user, setUser] = useLocalStorage("user", null);

    const BadgeToggle = ({ active, onClick, disabled }) => (
    <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={[
        "inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ring-1 transition",
        active
            ? "bg-green-100 text-green-800 ring-green-300 hover:bg-green-200"
            : "bg-red-100 text-red-800 ring-red-300 hover:bg-red-200",
        disabled ? "opacity-50 cursor-wait" : "cursor-pointer"
        ].join(" ")}
        title={active ? "Cliquer pour désactiver" : "Cliquer pour activer"}
    >
        {active ? "Actif" : "Inactif"}
    </button>
    );

    const [savingIds, setSavingIds] = useState(new Set()); // pour disable le badge pendant la sauvegarde

const handleToggleActive = async (account) => {
  const key = account.user_login;           // identifiant unique de la ligne (adapte si tu as un id)
  const next = account.active == 1 ? 0 : 1; // convertit 1/0

  // Optimistic UI
  setAccounts(prev =>
    prev.map(a => a.user_login === key ? { ...a, active: next } : a)
  );
  setSavingIds(prev => new Set(prev).add(key));

  try {
    // appelle ton endpoint: adapte l'URL/params si besoin
    const res = await callAPI('/set-account-active', {
      user_login: key,
      active: next,
      access_token: user.access_token
    });

    if (!res?.success) {
      throw new Error(res?.msg || "Echec MAJ statut");
    }
    toast.success(next ? "Compte activé" : "Compte désactivé");
  } catch (e) {
    // rollback si erreur
    setAccounts(prev =>
      prev.map(a => a.user_login === key ? { ...a, active: account.active } : a)
    );
    toast.error("Impossible de mettre à jour le statut");
    console.error(e);
  } finally {
    setSavingIds(prev => {
      const copy = new Set(prev);
      copy.delete(key);
      return copy;
    });
  }
};


    // Récupération de tous les comptes
    useEffect(() => {
        const fetchAccounts = async () => {
            try {
                const response = await callAPI('/get-all-accounts', {access_token: user.access_token});
               
                if (response.success) {
                    setAccounts(response.datas);
                } else {
                    alert("Vous n'êtes pas autorisé à voir ces informations");
                }
            } catch (error) {
                console.error("Erreur lors de la récupération des comptes :", error);
            }
        };
        fetchAccounts();
    }, []);

    // Mise à jour des suggestions lors de la saisie
    useEffect(() => {
        if (searchTerm.length > 1) {
            const matches = accounts.filter((acc) =>
                acc.user_login.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setSuggestions(matches.slice(0, 5)); // max 5 suggestions
        } else {
            setSuggestions([]);
        }
    }, [searchTerm, accounts]);

    // Connexion en tant qu'utilisateur sélectionné
    const impersonateAccount = async (user_login) => {
        console.log("Tentative d'impersonation de :", user_login);
        try {
            const response = await callAPI('/login-admin', { user_login, access_token: user.access_token });
           
            console.log("réponse : ", response);
            console.log("Access token utilisé avant mise à jour:", user.access_token);

            if (response.success) {
                toast.success(` Connexion réussie en tant que ${user_login}.`);  
               
                //  Extraire le bon access_token (celui du client)
                const newAccessToken = response.datas?.access_token;
                console.log("Nouveau token :", newAccessToken);

                if (!newAccessToken) {
                    toast.error("Erreur : Aucun access_token reçu !");
                    return;
                }

                // Mettre à jour l'utilisateur avec le nouvel access_token
                setUser({
                    user_login: response.datas.user_login,
                    id_global: response.datas.id_global,
                    role: response.datas.role,
                    access_token: newAccessToken,
                    url_bo: response.datas.url_bo
                });
                console.log("Nouveau Access Token :",  user.access_token);
                navigate("/dashboard");
            }
        } catch (error) {
            console.error("Erreur lors de la connexion", error);
        }
    };
    
    // Création de compte
    const handleCreateAccount = async (e) => {
        e.preventDefault();
        try {
            console.log("Envoi API création :", {
                email,
                id_global,
                id_contact,
                access_token: user.access_token
            });

            const response = await callAPI('/create-account', {
                email: email,
                id_global: id_global,
                id_contact: id_contact,
                access_token: user.access_token
            });

            if(response.success) {
                toast.success("Compte créé avec succès !");
                setShowForm(false);
            } else {
                toast.error("Erreur lors de la création du compte.");
            }

        } catch (error) {
            toast.error("Erreur réseau. Veuillez réessayer.");
            console.error('Erreur de création du compte :', error);
        }
    };

    // normalise 1 / "1" / true
    const isActive = (v) => v === 1 || v === "1" || v === true;

    const StatusBadge = ({ ok }) => (
    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium
        ${ok ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
        {ok ? "Actif" : "Inactif"}
    </span>
    );
const connectBtnClass = (ok) =>
  ok
    ? "bg-mlime text-white px-4 py-2 rounded-md shadow-sm duration-500 hover:bg-colorbutton transition"
    : "bg-gray-300 text-white px-4 py-2 rounded-md shadow-sm cursor-not-allowed";

    return (
        <div className="flex flex-col justify-between h-screen">
            <div className="header bg-mgray text-mdark py-8 px-10 text-center">
                <h1 className="text-xl sm:text-4xl font-extrabold text-mlime mb-4 uppercase">Meosis</h1>
                <p className="text-lg font-bold text-custom-color">Bienvenue dans votre espace Super Admin</p>
                <button className=" font-bold py-5 px-4 absolute top-0 right-0" onClick={logout}>
                    <FontAwesomeIcon className="mr-3" icon="fa-solid fa-arrow-right-from-bracket" />
                </button>
            </div>

            <div className="flex justify-between align-center m-10 gap-[30px]">
                <div className="relative flex items-center gap-2 mb-4 sm:w-1/2">
                    <input
                        type="text"
                        placeholder="Rechercher un email..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="flex-1 px-4 py-2 border rounded-md shadow-sm"
                    />
                    <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                    

                {suggestions.length > 0 && (
                    <ul className="absolute top-12 left-0 bg-white border w-full shadow-md z-10 mt-1 rounded-md">
                        {suggestions.map((sugg, idx) => (
                            <li
                                key={idx}
                                className="px-4 py-2 hover:bg-gray-100 cursor-default flex items-center justify-between"
                            >
                                <span>{sugg.user_login}</span>
                                <button
                                    onClick={() => impersonateAccount(sugg.user_login)}
                                    className="bg-mlime text-white px-3 py-1 text-sm rounded-md shadow-sm hover:bg-colorbutton transition ml-2"
                                >
                                    Se connecter
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
                <div className="flex justify-end">
                    {!showForm && (
                        <button 
                        className="bg-mlime text-white px-4 py-2 rounded-md shadow-sm duration-500 hover:bg-colorbutton transition"
                        onClick={() => setShowForm(true)}
                        >
                        Créer un compte
                        </button>
                    )}
                </div>

                {showForm && (
                    <div className="container mx-auto mt-6 p-4 rounded-md shadow-md border">
                        <h2 className="text-lg font-semibold mb-4">Créer un nouvel utilisateur</h2>
                        <form onSubmit={handleCreateAccount} className="space-y-4">
                            <Input
                                name="email"
                                label="Adresse email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full px-3 py-2 border rounded-md"
                            />
                            <Input
                                name="id_global"
                                label="ID Global"
                                value={id_global}
                                onChange={(e) => setIdGlobal(e.target.value)}
                                required
                                className="w-full px-3 py-2 border rounded-md"
                            />
                            <Input
                                name="id_contact"
                                label="ID Contact"
                                value={id_contact}
                                onChange={(e) => setIdContact(e.target.value)}
                                required
                                className="w-full px-3 py-2 border rounded-md"
                            />
                            <div className="flex gap-2">
                                <button 
                                type="submit"
                                className="bg-mlime text-white px-4 py-2 rounded-md shadow-sm duration-500 hover:bg-colorbutton transition"
                                >
                                Valider
                                </button>
                                <button
                                type="button"
                                onClick={() => setShowForm(false)}
                                className="bg-red-500 text-white px-4 py-2 rounded-md shadow-sm duration-500 hover:bg-red-600 transition"
                                >
                                Fermer
                                </button>
                            </div>
                        </form>
                    </div>
                )}
        </div>

            <div className="container mx-auto p-4">
                <table className="w-full border-collapse bg-white shadow-md rounded-md">
                    <thead className="bg-gray-100 text-gray-700">
                        <tr>
                            <th className="border border-gray-300 px-6 py-3 text-left rounded-t-md">Identifiant de connexion</th>
                            <th className="border border-gray-300 px-6 py-3 text-left rounded-t-md">Email</th>
                            <th className="border border-gray-300 px-6 py-3 text-left rounded-t-md">Id contrat global</th>
                            <th className="border border-gray-300 px-6 py-3 text-center rounded-t-md">Connexion</th>
                            <th className="border border-gray-300 px-6 py-3 text-center rounded-t-md">Compte actif</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accounts.map((account, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                                <td className="border border-gray-300 px-6 py-3">{account.user_login}</td>
                                <td className="border border-gray-300 px-6 py-3">{account.email}</td>
                                <td className="border border-gray-300 px-6 py-3">{account.id_global}</td>
                                <td className="border border-gray-300 px-6 py-3 text-center">
                                    <button
                                        onClick={() => impersonateAccount(account.user_login)}
                                        className="bg-mlime text-white px-4 py-2 rounded-md shadow-sm duration-500 hover:bg-colorbutton transition"
                                    >
                                        Se connecter
                                    </button>
                                </td>
                                <td className="border border-gray-300 px-6 py-3 text-center">
                                    <BadgeToggle
                                        active={account.active == 1}
                                        disabled={savingIds.has(account.user_login)}
                                        onClick={() => handleToggleActive(account)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Footer />
        </div>
    );
};

export default SuperAdmin;
